module.exports = __webpack_public_path__ + "img/American Express.52ad483a.png";